<template>
  <q-tab-panels v-model="currentValue" keep-alive animated>
    <slot />
  </q-tab-panels>
</template>

<script>
export default {
  name: 'TabPanels',
  props: {
    value: {
      type: [String, Number],
    },
  },
  computed: {
    currentValue: {
      set(val) {
        this.$emit('input', val);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.q-tab-panels ::v-deep {
  background-color: inherit;
}
</style>
